export const userToast = {
  create: 'User has been created successfully',
  update: 'Your profile has been updated successfully',
  delete: 'User has been deleted successfully',
  deleteConfirmation:
    'Are you sure you want to delete this user? This action cannot be undone',
  bulkUpload: 'File Uploaded Successfully',
  resetPassword: 'Password is updated successfully',
};

export const groupsToast = {
  create: 'The group has been created successfully',
  addUserToGroup: 'User(s) has / have been added to the group successfully',
  deleteConfirmation:
    'Are you sure you want to delete this group? This action cannot be undone',
  removeMember: 'The user has been removed from the group successfully',
  bulkAddUsers: 'File Uploaded Successfully',
  delete: 'The group has been deleted successfully',
  update: '	Group details have been updated successfully',
};

export const knowledgeBaseToast = {
  create: 'The folder has been created successfully',
  uploadFile: 'File uploaded successfully',
  urlWaiting: 'URL is being processed. Please wait while the content is loaded',
  deleteConfirmation:
    'Are you sure you want to delete this item? This action cannot be undone',
  refreshIndexer:
    'Indexer refresh in progress. Updates will be available shortly',
};

export const consoleBrandingToast = {
  save: 'Branding settings saved successfully',
  reset: 'Branding settings reset successfully', // @TODO check
};

export const categoriesToast = {
  add: 'Category added successfully',
  update: 'Category updated successfully',
  deleteConfirmation:
    'Are you sure you want to delete this category? This action cannot be undone',
};

export const themeToast = {
  save: 'Theme selection saved successfully',
};

export const sensitiveKeywordsToast = {
  add: 'Sensitive keyword added successfully',
  update: 'Sensitive keyword updated successfully',
  deleteConfirmation:
    'Are you sure you want to delete this keyword? This action cannot be undone',
  editCustomMessage: 'Custom message updated successfully',
};

export const voiceToast = {
  save: 'Voice settings updated successfully',
  reset: 'Voice language reset successfully', // @TODO check
};

export const workflowToast = {
  save: 'Workflow saved successfully',
  update: 'Workflow updated successfully',
  // @TODO check
  activateIncomplete:
    'This workflow is incomplete. Please ensure all steps are configured before activation',
  deactivateConfirm: 'Are you sure you want to deactivate this workflow?',
  deleteConfirmation:
    'Are you sure you want to delete this workflow? This action cannot be undone',
};

export const botToast = {
  create: 'Bot created successfully',
  copy: 'Bot script copied to clipboard',
};

export const termsConditionsToast = {
  save: 'Terms and conditions saved successfully',
};
